import Http from '@/Http';
import { GET_ENTERPRISE } from '@/store/models/work/enterprises';
import { Enterprise } from '@/types/work/enterprise';
import { Measure } from '@/types/work/product';

export const MEASURES_REQUEST = 'work/enterprises/measures/request';
export const UPDATE_MEASURE = 'work/enterprises/measures/updateRequest';
export const GET_MEASURE = 'work/enterprises/measures/get_measures';

const state = {
  status: null,
  measures: [],
  measure: {}
};

const getters = {
  get_measures: (state:any):null|boolean => state.measures
};

const actions = {
  request: ({ commit, rootGetters }:any) => {
    commit('request');
    let enterprise: Enterprise = rootGetters[GET_ENTERPRISE];
    (new Http()).request({ url: `enterprise/${enterprise.id}/measurements` })
      .then((resp:any) => {
        commit('success', resp.data.data);
      })
      .catch(() => {
        // if resp is unauthorized, logout, to
      });
  },
  updateRequest: ({ commit, rootGetters }:any, data:Measure) => {
    let validData = {
      title: data.title,
      short_title: data.short_title,
      parent_id: data.parent_id
    };
    commit('request');
    return new Promise((resolve, reject) => {
      let enterprise: Enterprise = rootGetters[GET_ENTERPRISE];
      (new Http()).request({ url: `enterprise/${enterprise.id}/measurements/${data.id}`, data: validData, method: 'POST' })
        .then((resp:any) => {
          if (resp.data.data) {
            commit('successStore', { resp: data, update: true });
          }
          resolve(resp.data.data);
        })
        .catch((e:any) => {
          commit('error');
          reject(e);
        });
    });
  }
};

const mutations = {
  request: (state:any) => {
    state.status = null;
  },
  success: (state:any, resp:Array<Measure>) => {
    state.status = true;
    state.measures = resp;
  },
  successStore: (state:any, { resp, update }:any) => {
    state.status = true;
    if (update) {
      let found = false;
      for (let i = 0; i < state.measures.length; i++) {
        if (state.measures[i].id === resp.id) {
          state.measures[i] = resp;
          found = true;
          break;
        }
      }
      if (!found) {
        state.measures[state.measures.length] = resp;
      }
    } else {
      state.measures[state.measures.length] = resp;
    }
  },
  error: (state:any) => {
    state.status = false;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
